import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  postal: {
    display: 'flex'
  },
  addressField: {
    margin: '0'
  },
  field: {
    marginBottom: theme.spacing(3)
  },
  postalCode: {
    width: '135px',
    margin: '0',
    marginRight: theme.spacing(5)
  },
  text: {
    textAlign: 'left'
  }
}));